import React, { forwardRef, } from 'react';
import { CnFormat as UICnFormat } from '@cainiaofe/cn-ui-m';
import { calculateTextExprValue, executeFunction, isArrayNotEmpty, isDesignMode, } from '@/common/util/util';
import cloneDeep from 'lodash/cloneDeep';
import isPlainObject from 'lodash/isPlainObject';
const CnFormat = forwardRef((props, ref) => {
    if (!UICnFormat) {
        return null;
    }
    const { formatSchema, _context, __getContextData__, __loopData__ } = props || {};
    const isDesign = isDesignMode(props);
    const functionArg = executeFunction(__getContextData__)?.functionArg;
    const { active, loop } = __loopData__ || {};
    let loopData = [];
    if (active) {
        loopData = executeFunction(loop, functionArg);
    }
    const calculateValue = (config) => {
        const { value, funcArg } = config || {};
        if (typeof value === 'function') {
            return executeFunction(value, {
                ...funcArg,
                state: _context?.state,
            });
        }
        else if (isPlainObject(value)) {
            const { __hasMockData__ } = value || {};
            if (__hasMockData__) {
                if (isDesign) {
                    if ((value?.value !== 0 && !value?.value) ||
                        (isPlainObject(value?.value) &&
                            Object.keys(value?.value).includes('__jsFunctionExecuteImmediately__'))) {
                        return value?.__mockValue__;
                    }
                    else if (typeof value?.value === 'string' &&
                        value?.value?.startsWith('__record__.')) {
                        const fieldKey = value?.value?.split('__record__.')[1];
                        return funcArg?.item?.[fieldKey];
                    }
                    else {
                        return calculateValue({
                            value: value?.value,
                            funcArg,
                        });
                    }
                }
                else {
                    return calculateValue({
                        value: value?.value,
                        funcArg,
                    });
                }
            }
            else {
                if (typeof value?.__jsFunctionExecuteImmediately__ === 'function') {
                    return executeFunction(value.__jsFunctionExecuteImmediately__, {
                        ...funcArg,
                        state: _context?.state,
                    });
                }
                const group = value?.group;
                const param = value?.param;
                if (typeof group === 'string' && group.startsWith('__')) {
                    if (group === '__value__') {
                        return funcArg?.value;
                    }
                    else {
                        if (param) {
                            return calculateTextExprValue(value, {
                                recordDataSource: funcArg?.item,
                                valueDataSource: funcArg?.value,
                            });
                        }
                        return undefined;
                    }
                }
                const result = {};
                for (const key in value) {
                    if (key) {
                        const v = value[key];
                        if (typeof v === 'function' &&
                            value[`__${key}ExecuteImmediately__`] !== true) {
                            result[key] = v;
                        }
                        else {
                            result[key] = calculateValue({
                                value: v,
                                funcArg,
                            });
                        }
                    }
                }
                return result;
            }
        }
        else if (typeof value === 'string' && value?.startsWith('__record__.')) {
            const fieldKey = value?.split('__record__.')[1];
            return funcArg?.item?.[fieldKey];
        }
        else {
            return value;
        }
    };
    // 过时遍历，暂存
    // const recursiveFormatSchema = (config) => {
    //   const {options, funcArg} = config || {}
    //   if(isPlainObject(options)){
    //     for (const key in options){
    //       const value = options[key]
    //       if(typeof value === 'function') {
    //         options[key] = executeFunction(value, {
    //           ...funcArg,
    //           state: _context?.state })
    //       }else if(isPlainObject(value)){
    //         const { __hasMockData__ } = value || {}
    //         if(__hasMockData__) {
    //           if(isDesign) {
    //             if(value?.value !== 0 && !value?.value) {
    //               options[key] = value?.__mockValue__
    //             }
    //           }else {
    //             // if(isPlainObject(value)) {
    //             //
    //             // }
    //             // options[key] = value?.value
    //           }
    //         }else {
    //           recursiveFormatSchema({options:value,funcArg})
    //         }
    //       }
    //       if(isDesign) {
    //         if(key.endsWith('Mock') && options[key]) {
    //           const targetKey = key.slice(0,-4)
    //           if(!options[targetKey]) {
    //             options[targetKey] = options[key];
    //           }
    //         }
    //         if(!isNil(options[key+'Mock'])) {
    //           if(!options[key]) {
    //             options[key] = options[key+'Mock'];
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
    const transformFormatSchema = (funcArg) => {
        const newFormatSchema = cloneDeep(formatSchema);
        if (isArrayNotEmpty(formatSchema)) {
            for (const newFormatSchemaKey in newFormatSchema) {
                const item = newFormatSchema[newFormatSchemaKey];
                if (isPlainObject(item)) {
                    const { options } = item || {};
                    // recursiveFormatSchema({options,funcArg})
                    const newOptions = calculateValue({ value: options, funcArg });
                    newFormatSchema[newFormatSchemaKey] = {
                        ...item,
                        options: undefined,
                        ...newOptions,
                    };
                }
            }
        }
        return newFormatSchema;
    };
    if (active) {
        if (!isArrayNotEmpty(loopData) && isDesign) {
            loopData = [{}];
        }
        if (isArrayNotEmpty(loopData)) {
            return loopData.map((item, index) => {
                const funcArg = {
                    item,
                    index,
                    state: _context?.state,
                    _context,
                };
                return (React.createElement(UICnFormat, { format: 'CnFormatArrayView2', value: transformFormatSchema(funcArg), __getContextData__: () => {
                        return {
                            functionArg: funcArg,
                        };
                    } }));
            });
        }
    }
    else {
        return (React.createElement(UICnFormat, { format: 'CnFormatArrayView2', value: transformFormatSchema(functionArg), __getContextData__: props?.__getContextData__ }));
    }
});
CnFormat.displayName = 'CnFormat';
export default CnFormat;
